import { Typography } from '@packages/ui/shared';
import { DetailHeader } from '@web/components/detail-view';
import { useTranslation } from 'react-i18next';

import type { Ssm5FreezeFramesTarget } from '../helpers/ssm5-paths';

import { ssm5FreezeFramesPath, ssm5SessionPath } from '../helpers/ssm5-paths';
import { ssm5TextStyles } from '../ssm5.styles';

/** Props for {@link Ssm5FreezeFramesHeader}. */
export type Ssm5FreezeFramesHeaderProps = {
    /** The trouble code. */
    dtcCode: string;
    /** The event text without its label, when reported. */
    eventDetail?: string;
    /** The DTC whose data is shown. */
    target: Ssm5FreezeFramesTarget;
    /** The VIN of the session. */
    vin: string;
};

/**
 * The breadcrumb, DTC code and optional event detail of the freeze frame page.
 *
 * @param props - {@link Ssm5FreezeFramesHeaderProps}
 * @returns the page header
 */
export function Ssm5FreezeFramesHeader({ dtcCode, eventDetail, target, vin }: Ssm5FreezeFramesHeaderProps) {
    const { t } = useTranslation();
    const rightSideItems =
        eventDetail === undefined
            ? []
            : [
                  <Typography color="textDarkSecondary" key="event" style={ssm5TextStyles.body} variant="default">
                      {t('ssm5:ffd.eventDetail', { detail: eventDetail })}
                  </Typography>,
              ];

    return (
        <DetailHeader
            breadcrumbs={[
                { title: t('ssm5:title'), to: ssm5SessionPath(vin) },
                { title: t('ssm5:ffd.breadcrumb'), to: ssm5FreezeFramesPath(vin, target) },
            ]}
            hasBack
            look="tokens"
            rightSideItems={rightSideItems}
            subtitle={dtcCode}
        />
    );
}
